module.exports = __webpack_public_path__ + "static/media/Logo.baba1f0b.svg";